'use client';
import { MotionValue, motion, useTransform } from 'framer-motion';
import type * as React from 'react'
import Image from 'next/image';

import { Developer } from './developers';
import styles from './developersHero.module.scss';

const COLLAGE_SLOTS: {
  top: number;
  left: number;
  width: number;
  ratio: number;
  depth: number;
}[] = [
  { top: 11, left: 2, width: 30, ratio: 0.86, depth: -70 }, // top-left
  { top: 9, left: 44, width: 27, ratio: 0.82, depth: -120 }, // top-center
  { top: 12, left: 69, width: 34, ratio: 0.74, depth: -80 }, // top-right
  { top: 70, left: 62, width: 34, ratio: 0.62, depth: -80 }, // bottom-right
  { top: 75, left: 3, width: 31, ratio: 0.82, depth: -120 }, // bottom-left
  { top: 83, left: 27, width: 27, ratio: 0.9, depth: -170 }, // bottom-center
];

export const COLLAGE_COUNT = COLLAGE_SLOTS.length;

export const CollageCard = ({
  dev,
  index,
  progress,
  reducedMotion,
}: {
  dev: Developer;
  index: number;
  progress: MotionValue<number>;
  reducedMotion: boolean;
}) => {
  const slot = COLLAGE_SLOTS[index];
  const y = useTransform(progress, [0, 1], [0, reducedMotion ? 0 : slot.depth]);

  return (
    <motion.div
      className={styles.collageCard}
      style={
        {
          '--top': `${slot.top}%`,
          '--left': `${slot.left}%`,
          '--w': `${slot.width}%`,
          '--ratio': slot.ratio,
          y,
        } as unknown as React.CSSProperties
      }
      initial={reducedMotion ? false : { opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        delay: 0.04 * index,
        ease: [0.2, 0.7, 0.7, 1],
      }}
    >
      <Image
        className={styles.cardImage}
        src={dev.image}
        alt=""
        fill
        sizes="50vw"
      />
    </motion.div>
  );
};
